import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmSelectJourneyActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/fmlmSelectJourneyActionParams";
import { IFmlmView } from "../../../Orchestrator/Types/Interface/IFmlmView";

export class FmlmSelectJourneyAction extends BaseAction<
  IFmlmView,
  IFmlmSelectJourneyActionParams
> {
  override async run(): Promise<IFmlmView | null> {
    const { id, fmlmViewList, trainType } = this.params!;

    const selectedFmlmJourney = fmlmViewList.find((view) => view.id === id);

    if (selectedFmlmJourney) {
      if (trainType === "outbound") {
        updateRecoilState("selectedFmlmJourneyAtom", selectedFmlmJourney);
        updateRecoilState("selectedOutboundTrainAtom", null);
      } else if (trainType === "inbound") {
        updateRecoilState("selectedInboundFmlmJourneyAtom", selectedFmlmJourney);
        updateRecoilState("selectedInboundTrainAtom", null);
      }

      updateRecoilState("offerAtom", []);
      updateRecoilState("tripOfferAtom", []);
    }

    return selectedFmlmJourney || null;
  }
}

// Create a singleton instance
export const fmlmSelectJourneyAction = new FmlmSelectJourneyAction();
